import script from "./PedalFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./PedalFilters.vue?vue&type=script&setup=true&lang=ts"

import "./PedalFilters.vue?vue&type=style&index=0&id=0480791b&lang=scss"

const __exports__ = script;

export default __exports__